import { styled } from 'styled-components';
import { HStack } from '@montel/montelpro-shared-components-v2';

export const StyledProfileButton = styled(HStack).attrs({ gap: 'sm' })`
	cursor: pointer;
`;
